import Request from './request'

const SimcardOperatorApn = {
  getSimcardOperatorApn(params, callback) {
    Request.get('simcard-operator-apn/index', params).then(callback).catch(this.bad_answer)
  },
  getSimcardOperatorApnInfo(id, callback, bad_answer) {
    Request.get('simcard-operator-apn/view/' + id).then(callback).catch(bad_answer || this.bad_answer)
  },
}
export default SimcardOperatorApn
